import {
  AlignItems,
  Box,
  ColorPreset,
  H3,
  JustifyContent,
  P,
  Text,
  TextAlign,
  TypePreset,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";
import Image from "next/image";

import { IBPPromoTransactionAnimation } from "./IBPPromoTransactionAnimation";

import IBPSignInPromo from "src/assets/png/IBP-static-sign-in-promo-new.png";

export const SignInMarketing = () => (
  <Box
    layout="flex"
    alignItems={AlignItems.Center}
    justifyContent={JustifyContent.Center}
    minHeight="100dvh"
    gutterV={6}
    gutterH={3}
  >
    <Box layout="flex" flexDirection="column" alignItems={AlignItems.Center}>
      <Box
        layout="flex"
        css={{ position: "relative", transform: "scale(0.9)" }}
        justifyContent={JustifyContent.Center}
        spaceBelow={1}
      >
        <Image
          src={IBPSignInPromo}
          alt="The easy way to collect payments"
          width={240}
          height={515}
          style={{
            height: "auto",
            position: "relative",
          }}
        />
        <IBPPromoTransactionAnimation />
      </Box>
      <Box css={{ textWrap: "balance" }}>
        <H3
          color={ColorPreset.TextOnLight_01}
          spaceBelow={1}
          size={9}
          textAlign={TextAlign.Center}
        >
          <Trans>Instant payments.</Trans>
          <Text layout="block">
            <Trans> Without card fees.</Trans>
          </Text>
        </H3>
        <Box maxWidth="500px">
          <P
            color={ColorPreset.TextOnLight_01}
            preset={TypePreset.Body_03}
            textAlign={TextAlign.Center}
          >
            <Trans>
              For payments you need authorised immediately, choose Instant Bank
              Pay. No annoying admin.
            </Trans>
          </P>
        </Box>
      </Box>
    </Box>
  </Box>
);
